import { SearchSearchSuccessSchema } from '~/services/api/generated'
import type {
  SearchCategoriesSuccess,
  SearchDietaryOptionsSuccess,
  SearchPopularTagsSuccess,
  SearchSearchQuery,
  SearchTagsSuccess
} from '~/services/api/generated'
import type { z } from 'zod'

// featured_sort_order is a plain number|string on the wire (StoreSearchEntry); no codec needed.
export const searchSearchSuccessCodecSchema = SearchSearchSuccessSchema

export type SearchSearchSuccessCodec = z.output<typeof searchSearchSuccessCodecSchema>

type StoreSearchWireResult = SearchSearchSuccessCodec['data']['stores'][number]

export type SearchRequest = SearchSearchQuery

export type StoreSearchResult = Omit<
  StoreSearchWireResult,
  | 'average_rating'
  | 'review_count'
  | 'created_at'
  | 'delivery_fee'
  | 'delivery_radius'
  | 'distance_miles'
  | 'latitude'
  | 'longitude'
> & {
  average_rating: number | null
  review_count: number
  created_at: string
  delivery_fee: number | null
  delivery_radius: number | null
  latitude: number | null
  longitude: number | null
  distance_miles?: number | null
  distance?: number | null
}

export type SearchResponse = Omit<SearchSearchSuccessCodec, 'data'> & {
  data: Omit<SearchSearchSuccessCodec['data'], 'stores'> & { stores: StoreSearchResult[] }
}

export type SearchCategory = Pick<
  SearchCategoriesSuccess['data']['categories'][number],
  'id' | 'name' | 'slug'
>

export type SearchDietaryOption = Pick<
  SearchDietaryOptionsSuccess['data']['dietaryOptions'][number],
  'id' | 'name' | 'slug'
>

export type SearchPopularTag = Pick<
  SearchPopularTagsSuccess['data']['tags'][number],
  'description' | 'id' | 'name' | 'slug'
>

export type SearchTag = SearchTagsSuccess['data']['tags'][string][number]
